// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".history-filter span[data-v-844f8496]{color:var(--text-disable);-webkit-transition:color .3s;-o-transition:color .3s;transition:color .3s}.history-filter span.active[data-v-844f8496],.history-filter span[data-v-844f8496]:hover{color:var(--text-default)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
